import api from '../../store/config/api';
import { INVITE as SCHEMA } from '../../schemas';
import { schema } from 'normalizr'; // eslint-disable-line no-unused-vars

export const [
  ADD_INVITE,
  ADD_INVITE_REQUEST,
  ADD_INVITE_SUCCESS,
  ADD_INVITE_FAILURE
] = api.buildTypes('ADD_INVITE');

export function addInvite({
  teamName,
  email,
  message,
  notificationPreference,
  phone,
  isAdmin,
  isRestricted
}) {
  return {
    type: ADD_INVITE,
    payload: {
      url: `/teams/${teamName}/invites`,
      transform: input => {
        const { inviteToken: inviteID, ...options } = input;
        return { inviteID, ...options };
      },
      schema: SCHEMA,
      options: {
        method: 'POST',
        body: {
          email,
          message,
          phone,
          notificationPreference,
          isAdmin,
          isRestricted
        }
      }
    }
  };
}

export const [
  GET_INVITE,
  GET_INVITE_REQUEST,
  GET_INVITE_SUCCESS,
  GET_INVITE_FAILURE
] = api.buildTypes('GET_INVITE');

export function getInvite({ teamName, id }) {
  return {
    type: GET_INVITE,
    payload: {
      url: `/teams/${teamName}/invites/${id}`,
      transform: input => ({ inviteID: id, ...input }),
      schema: SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}

export const [
  ACCEPT_INVITE,
  ACCEPT_INVITE_REQUEST,
  ACCEPT_INVITE_SUCCESS,
  ACCEPT_INVITE_FAILURE
] = api.buildTypes('ACCEPT_INVITE');

export function acceptInvite({ teamName, id, userData, usingSamlSso }) {
  const { email, username, fullName, password } = userData;
  return {
    type: ACCEPT_INVITE,
    payload: {
      url: `/teams/${teamName}/invites/${id}`,
      transform: input => ({ inviteID: id, ...input }),
      schema: SCHEMA,
      options: {
        method: 'POST',
        body: {
          email,
          username,
          fullName,
          password,
          usingSamlSso
        }
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/invite.js